import YardIcon from '@mui/icons-material/Yard';
import {
	Avatar,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { DashboardFragrancesModel } from '~/model/model.dashboard.fragrances';
import { UIService } from '~/service/service.ui';
import { useModel, useService } from '~/shared/service/service.base';
import { GridNoRows } from '../grid/grid.norows';
import { AsyncView } from '../view.async';

export const DashboardFragrancesDialog = observer(() => {
	const [ui] = useService(UIService);
	const model = useModel(DashboardFragrancesModel);
	const open = ui.dialog === DashboardFragrancesDialog;

	useEffect(() => {
		if (open) model.fetchData();
	}, [model, open]);

	return (
		<Dialog open={open} fullWidth maxWidth="sm" onClose={ui.hideDialog}>
			<DialogTitle>Top fragrances that received 5 stars from users</DialogTitle>
			<DialogContent>
				<AsyncView async={model.async}>
					<List sx={{ height: '50vh' }}>
						<Virtuoso
							data={model.items}
							itemContent={(_, item) => (
								<ListItem key={item.id} dense>
									<ListItemAvatar>
										<Avatar variant="rounded" src={item.images?.at(0)}>
											<YardIcon />
										</Avatar>
									</ListItemAvatar>
									<ListItemText primary={item.name} secondary={item.count} />
								</ListItem>
							)}
							components={{
								EmptyPlaceholder: () => <GridNoRows>No fragrances</GridNoRows>,
							}}
						/>
					</List>
				</AsyncView>
			</DialogContent>
			<DialogActions>
				<Button onClick={ui.hideDialog}>Close</Button>
			</DialogActions>
		</Dialog>
	);
});
